import { createContext, useContext } from "react";
const LayerContext = createContext({});
/**
 * Provides the layer created by the various layer components. Available to children of the layer components.
 */
export function useLayerContext() {
    return useContext(LayerContext);
}
export default LayerContext;
